import { useMemo } from 'react'

import classnames from 'classnames/bind'
import slugify from 'slugify'
import { ChargingStation } from 'types/charing-types'
import s from './Table.module.scss'

type TableProps = {
  data: ChargingStation[]
  title: string
  headers: string[]
  smallerTitle?: boolean
}

export const Table = ({ data, title, headers, smallerTitle }: TableProps) => {
  const tableHeaders =
    data[0] && (Object.keys(data[0]) as Array<keyof ChargingStation>)
  const c = classnames.bind(s)

  const sortedData = useMemo(() => {
    return data.sort((a, b) => {
      if (a.title && b.title) {
        return a.title.localeCompare(b.title)
      }
      return 0
    })
  }, [data])

  return (
    <div className={s.container} id={slugify(title)}>
      <table className={s.table}>
        <caption className={c(s.caption, smallerTitle && s.smallerTitle)}>
          {title}
        </caption>
        <thead className={s.thead}>
          <tr>
            {headers?.map((header: string) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody className={s.tbody}>
          {sortedData.map((item, index) => (
            <tr key={index}>
              {tableHeaders.map((header) => (
                <td key={header} className={s.cell}>
                  {item[header] as string}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
